import FetcherFactory from '../../fetcher/Fetchers/factory.js'
import {LastCallErrorsFactory} from '../Errors/factory.js'
import {LastCallValueObjectFactory} from '../ValueObjects/factory.js'
import {HTTPLastCallRepository} from './HTTPLastCallRepository.js'

export class LastCallRepositoriesFactory {
  static hTTPLastCallRepository = ({config}) =>
    new HTTPLastCallRepository({
      config,
      fetchOrFail: FetcherFactory.fetchOrFail({
        config
      }),
      createLastCallResponseValueObject: LastCallValueObjectFactory.createLastCallResponseValueObject,
      createMultipleLastCallsResponseValueObject: LastCallValueObjectFactory.createMultipleLastCallsResponseValueObject,
      dealerNotFoundError: LastCallErrorsFactory.dealerNotFoundError,
      invalidUserError: LastCallErrorsFactory.invalidUserError,
      lastCallAlreadyExistsError: LastCallErrorsFactory.lastCallAlreadyExistsError,
      showLastCallError: LastCallErrorsFactory.showLastCallError,
      showLastCallValueObject: LastCallValueObjectFactory.showLastCallValueObject
    })
}
